import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
const API_URL = `${API_BASE}/financiero/portal-estudiante`;

// Configurar axios para incluir el token de autenticación
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Obtiene el estado de cuenta completo de un estudiante
 * Incluye: resumen financiero, cargos pendientes e historial de pagos
 * @param {number} estudianteId - ID del estudiante
 * @returns {Promise} - Datos del estado de cuenta
 */
export const getEstadoCuentaEstudiante = async (estudianteId) => {
  try {
    const response = await axios.get(`${API_URL}/${estudianteId}/estado-cuenta/`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener estado de cuenta:', error);
    throw error;
  }
};

/**
 * Registra un pago desde el Portal de Estudiantes
 * El pago queda en estado PENDIENTE_VALIDAR hasta que un admin lo apruebe
 * @param {object} pagoData - Datos del pago
 * @returns {Promise} - Respuesta del servidor
 * 
 * Formato:
 * {
 *   id_estudiante: number,
 *   id_cargo: number,
 *   monto: number,
 *   referencia_bancaria: string (opcional)
 * }
 */
export const registrarPagoPortal = async (pagoData) => {
  try {
    const response = await axios.post(`${API_URL}/pagar/`, pagoData);
    return response.data;
  } catch (error) {
    console.error('Error al registrar pago:', error);
    
    // Extraer mensaje de error del servidor
    if (error.response && error.response.data) {
      throw {
        message: error.response.data.error || 'Error al registrar pago',
        details: error.response.data
      };
    }
    
    throw error;
  }
};

/**
 * Formatear monto para mostrar en interfaz
 * @param {number} monto - Monto numérico
 * @returns {string} - Monto formateado con separador de miles y 2 decimales
 */
export const formatearMonto = (monto) => {
  if (!monto && monto !== 0) return '$0.00';
  return `$${parseFloat(monto).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
